var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8640_95017",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90C0 40.2944 40.2944 0 90 0C139.706 0 180 40.2944 180 90C180 139.706 139.706 180 90 180C40.2944 180 0 139.706 0 90Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 90C0 40.2944 40.2944 0 90 0C139.706 0 180 40.2944 180 90C180 139.706 139.706 180 90 180C40.2944 180 0 139.706 0 90Z",
    fill: "#F6F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 88C0 38.2944 40.2944 -2 90 -2C139.706 -2 180 38.2944 180 88V90C180 41.3989 139.706 2 90 2C40.2944 2 0 41.3989 0 90V88ZM180 92C180 141.706 139.706 182 90 182C40.2944 182 0 141.706 0 92V90C0 138.601 40.2944 178 90 178C139.706 178 180 138.601 180 90V92ZM0 180V0V180ZM180 0V180V0Z",
    fill: "#120047",
    mask: "url(#path-1-inside-1_8640_95017)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3084 75.8824C78.3084 69.2315 83.7357 63.8667 90.3973 63.8667C97.059 63.8667 102.486 69.2315 102.486 75.8824C102.486 82.5333 97.059 87.8981 90.3973 87.8981C83.7357 87.8981 78.3084 82.5333 78.3084 75.8824ZM90.3973 68.1334C86.0624 68.1334 82.5751 71.6175 82.5751 75.8824C82.5751 80.1472 86.0624 83.6314 90.3973 83.6314C94.7323 83.6314 98.2196 80.1472 98.2196 75.8824C98.2196 71.6175 94.7323 68.1334 90.3973 68.1334ZM66.9307 106.941C66.9307 100.29 72.3579 94.9255 79.0196 94.9255H101.775C108.437 94.9255 113.864 100.29 113.864 106.941V114C113.864 115.178 112.909 116.133 111.731 116.133H69.064C67.8858 116.133 66.9307 115.178 66.9307 114V106.941ZM79.0196 99.1922C74.6846 99.1922 71.1973 102.676 71.1973 106.941V111.867H109.597V106.941C109.597 102.676 106.11 99.1922 101.775 99.1922H79.0196Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.996d682cf722821b8a766e42bbbc0627.svg";
export { ForwardRef as ReactComponent };